import { inject, injectable } from "inversify";
import { IF360Validator } from "./F360Validator";
import { DIMixins, IUserProfile } from "@/core/@types/types";
import "reflect-metadata";
import type { IUserProfileStorageMixin } from "@/core/plugins/storage/UserProfileStorageMixin";

@injectable()
export default class ShowEducaValidator implements IF360Validator {
  @inject(DIMixins.USER_PROFILE_STORAGE)
  userProfileMixin!: IUserProfileStorageMixin;

  private showEduca(profile: IUserProfile) {
    const isBaseTesteEduca = profile?.CodigoCliente == "TES-4365";
    if (isBaseTesteEduca) return true;

    const isCielo = profile?.CodigoCliente?.includes("CLO");
    if (isCielo) return false;

    const isBaseDeTestes = profile?.Perfil == 3;
    if (isBaseDeTestes) return false;

    return true;
  }

  handleValidation(): boolean {
    const profile = this.userProfileMixin.handleGetUserProfile();

    if (!profile || !profile.CodigoCliente || !profile.Perfil) return false;

    return this.showEduca(profile);
  }
}
